import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton, Typography } from '@mui/material';
import { ReactNode } from 'react';
import styled from 'styled-components';

const TopContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-gap: 12px;
`;

export interface ActivityProps {
  title: ReactNode;
  subtitle: ReactNode;
  icon: ReactNode;
  callback: () => void;
  disabled?: boolean;
}

const Activity = ({
  title,
  subtitle,
  icon,
  callback,
  disabled,
}: ActivityProps) => {
  return (
    <TopContainer>
      {icon}
      <div>
        <div>
          <Typography variant="titleMedium">{title}</Typography>
        </div>
        <div>
          <Typography variant="bodyMedium">{subtitle}</Typography>
        </div>
      </div>
      <div>
        <IconButton onClick={callback} disabled={disabled}>
          <ChevronRightIcon />
        </IconButton>
      </div>
    </TopContainer>
  );
};

export default Activity;
